import {
  resolveDescriptor,
  resolveMinMax, resolveMinMaxDescription,
} from '../../../../util/searchParamNameUtils';

export const resolveSearchParameters = ({
  params: {
    id,
    minId,
    maxId,
    year,
    have,

    authorStart,
    authorInclude,
    authorMatch,
    authorNot,

    citStart,
    citInclude,
    citMatch,
    citNot,

    commentsStart,
    commentsInclud,
    commentsMatch,
    commentsNot,

    eqAssoc,
    eqId,
    eqMinId,
    eqMaxId,
    eqMinYear,
    eqMaxYear,
    eqRegion,
    eqCountry,
    eqArea,
    eqMinLatitude,
    eqMaxLatitude,
    eqMinLongitude,
    eqMaxLongitude,
    eqMinEqMagnitude,
    eqMaxEqMagnitude,
    eqMinIntensity,
    eqMaxIntensity,
    eqMinEqDepth,
    eqMaxEqDepth,
    eqMinDeaths,
    eqMaxDeaths,
    eqMinDeathsAmountOrder,
    eqMaxDeathsAmountOrder,
    eqMinDamageMillionsDollars,
    eqMaxDamageMillionsDollars,
    eqMinDamageAmountOrder,
    eqMaxDamageAmountOrder,
    eqMinDeathsTotal,
    eqMaxDeathsTotal,
    eqMinDeathsAmountOrderTotal,
    eqMaxDeathsAmountOrderTotal,
    eqLocStart,
    eqLocMatch,
    eqLocInclude,
    eqLocNot,
    eqCommentsStart,
    eqCommentsMatch,
    eqCommentsInclude,
    eqCommentsNot,
    eqAssocVol,
    eqAssocTsu,

    volAssoc,
    volId,
    volMinId,
    volMaxId,
    volMinYear,
    volMaxYear,
    volCountry,
    volRegion,
    volMinLongitude,
    volMaxLongitude,
    volMinLatitude,
    volMaxLatitude,
    volVolcanoNames,
    volMorphology,
    volMinVei,
    volMaxVei,
    volMinDeaths,
    volMaxDeaths,
    volMinDeathsAmountOrder,
    volMaxDeathsAmountOrder,
    volMinDamageMillionsDollars,
    volMaxDamageMillionsDollars,
    volMinDamageAmountOrder,
    volMaxDamageAmountOrder,
    volAssocEq,
    volAssocTsu,
    volNameStart,
    volNameInclude,
    volNameMatch,
    volNameNot,
    volLocStart,
    volLocInclude,
    volLocMatch,
    volLocNot,
    volCommentsStart,
    volCommentsEnd,
    volCommentsInclude,
    volCommentsMatch,
    volCommentsNot,

    volLocAssoc,
    volLocMinLongitude,
    volLocMaxLongitude,
    volLocMinLatitude,
    volLocMaxLatitude,
    volLocCountry,
    volLocMorphology,
    volLocStatus,
    volLocTimeErupt,
    volLocRegion,
    volLocNameInclude,
    volLocNameMatch,
    volLocNameStart,
    volLocNameNot,

    tsuAssoc,
    tsuId,
    tsuMinId,
    tsuMaxId,
    tsuMinYear,
    tsuMaxYear,
    tsuRegionCode,
    tsuCauseCode,
    tsuCountry,
    tsuArea,
    tsuMinLatitude,
    tsuMaxLatitude,
    tsuMinLongitude,
    tsuMaxLongitude,
    tsuMinEventValidity,
    tsuMaxEventValidity,
    tsuMinCauseCode,
    tsuMaxCauseCode,
    tsuMinEqMagnitude,
    tsuMaxEqMagnitude,
    tsuRunupRegion,
    tsuRunupCountry,
    tsuRunupArea,
    tsuRunupMinDistance,
    tsuRunupMaxDistance,
    tsuRunupMinTravelTime,
    tsuRunupMaxTravelTime,
    tsuMinNumRunups,
    tsuMaxNumRunups,
    tsuMinMaxWaterHeight,
    tsuMaxMaxWaterHeight,
    tsuMinDeaths,
    tsuMaxDeaths,
    tsuMinDeathsAmountOrder,
    tsuMaxDeathsAmountOrder,
    tsuMinInjuries,
    tsuMaxInjuries,
    tsuMinInjuriesAmountOrder,
    tsuMaxInjuriesAmountOrder,
    tsuMinDamageMillionsDollars,
    tsuMaxDamageMillionsDollars,
    tsuMinDamageAmountOrder,
    tsuMaxDamageAmountOrder,
    tsuMinHousesDestroyed,
    tsuMaxHousesDestroyed,
    tsuMinHousesDestroyedAmountOrder,
    tsuMaxHousesDestroyedAmountOrder,
    tsuMinDeathsTotal,
    tsuMaxDeathsTotal,
    tsuMinDeathsAmountOrderTotal,
    tsuMaxDeathsAmountOrderTotal,
    tsuMinDamageMillionsDollarsTotal,
    tsuMaxDamageMillionsDollarsTotal,
    tsuMinDamageAmountOrderTotal,
    tsuMaxDamageAmountOrderTotal,
    tsuRunupMeasureType,
    tsuRunupDoubtful,
    tsuRunupMinHeight,
    tsuRunupMaxHeight,
    tsuRunupMinDeaths,
    tsuRunupMaxDeaths,
    tsuRunupMinDeathsAmountOrder,
    tsuRunupMaxDeathsAmountOrder,
    tsuRunupMinInjuries,
    tsuRunupMaxInjuries,
    tsuRunupMinInjuriesAmountOrder,
    tsuRunupMaxInjuriesAmountOrder,
    tsuRunupMinDamageMillionsDollars,
    tsuRunupMaxDamageMillionsDollars,
    tsuRunupMinDamageAmountOrder,
    tsuRunupMaxDamageAmountOrder,
    tsuRunupMinHousesDestroyed,
    tsuRunupMaxHousesDestroyed,
    tsuRunupMinHousesDestroyedAmountOrder,
    tsuRunupMaxHousesDestroyedAmountOrder,
    tsuLocStart,
    tsuLocEnd,
    tsuLocInclude,
    tsuLocMatch,
    tsuLocNot,
    tsuCommentsStart,
    tsuCommentsEnd,
    tsuCommentsInclude,
    tsuCommentsMatch,
    tsuCommentsNot,
    tsuRunupLocStart,
    tsuRunupLocEnd,
    tsuRunupLocInclude,
    tsuRunupLocMatch,
    tsuRunupLocNot,

    depAssoc,
    depId,
    depMinId,
    depMaxId,
    depMinYear,
    depMaxYear,
    depAuthorStart,
    depAuthorInclude,
    depAuthorMatch,
    depAuthorNot,
    depPublicationType,
    depEventStart,
    depEventInclude,
    depEventMatch,
    depEventNot,
    depMinGeologicAgeId,
    depMaxGeologicAgeId,
    depBodyOfWater,
    depCountry,
    depLocStart,
    depLocInclude,
    depLocMatch,
    depLocNot,
    depMinLatitude,
    depMaxLatitude,
    depMinLongitude,
    depMaxLongitude,

    runupAssoc,
    runupId,
    runupMinId,
    runupMaxId,
    runupSourceMinYear,
    runupSourceMaxYear,
    runupSourceRegionCode,
    runupSourceCountry,
    runupSourceArea,
    runupSourceMinEventValidity,
    runupSourceMaxEventValidity,
    runupSourceMinCauseCode,
    runupSourceMaxCauseCode,
    runupSourceMinEqMagnitude,
    runupSourceMaxEqMagnitude,
    runupRegionCode,
    runupCountry,
    runupArea,
    runupRunupCountry,
    runupRunupArea,
    runupMinDistFromSource,
    runupMaxDistFromSource,
    runupMinLatitude,
    runupMaxLatitude,
    runupMinLongitude,
    runupMaxLongitude,
    runupTypeMeasurementId,
    runupMinRunupHt,
    runupMaxRunupHt,
    runupMinDeaths,
    runupMaxDeaths,
    runupMinDeathsAmountOrder,
    runupMaxDeathsAmountOrder,
    runupMinDamageMillionsDollars,
    runupMaxDamageMillionsDollars,
    runupMinDamageAmountOrder,
    runupMaxDamageAmountOrder,
    runupMinInjuries,
    runupMaxInjuries,
    runupMinInjuriesAmountOrder,
    runupMaxInjuriesAmountOrder,
    runupMinHousesDestroyed,
    runupMaxHousesDestroyed,
    runupMinHousesDestroyedAmountOrder,
    runupMaxHousesDestroyedAmountOrder,
    runupMinHousesDamaged,
    runupMaxHousesDamaged,
    runupMinHousesDamagedAmountOrder,
    runupMaxHousesDamagedAmountOrder,
    runupMinTravHours,
    runupMaxTravHours,
    runupDoubtful,
    runupMinRunupHoriz,
    runupMaxRunupHoriz,
    runupLocStart,
    runupLocInclude,
    runupLocMatch,
    runupLocNot,
    runupCommentsStart,
    runupCommentsInclude,
    runupCommentsMatch,
    runupCommentsNot,
    runupTsunamiEventId,
    runupMinTroughHt,
    runupMaxTroughHt,
  },

  eqRegions,

  volRegions,

  volLocRegions,

  tsuRegions,
  tsuValidities,
  tsuCauses,
  tsuRunupMeasurementTypes,

  depGeologicAges,
  depPublicationTypes,

  runupRegions,
  runupValidities,
  runupCauses,
  runupRunupMeasurementTypes,

  peopleDescriptors,
  damageDescriptors,
  housesDescriptors,

  haves,
}) => {
  const messages = [];

  if (id != null) {
    messages.push(`ID = ${id}`);
  }

  resolveMinMax('ID', minId, maxId, messages);

  if (have != null) {
    messages.push(`Have = ${resolveDescriptor(haves, have)}`);
  }

  if (year != null) {
    messages.push(`Year = ${year}`);
  }

  if (authorStart != null) {
    messages.push(`Author starts with '${authorStart}'`);
  }

  if (authorInclude != null) {
    messages.push(`Author = '${authorInclude}'`);
  }

  if (authorMatch != null) {
    messages.push(`Author contains '${authorMatch}'`);
  }

  if (authorNot != null) {
    messages.push(`Author != '${authorNot}'`);
  }

  if (citStart != null) {
    messages.push(`Citation starts with '${citStart}'`);
  }

  if (citInclude != null) {
    messages.push(`Citation = '${citInclude}'`);
  }

  if (citMatch != null) {
    messages.push(`Citation contains '${citMatch}'`);
  }

  if (citNot != null) {
    messages.push(`Citation != '${citNot}'`);
  }

  if (commentsStart != null) {
    messages.push(`Comments start with '${commentsStart}'`);
  }

  if (commentsMatch != null) {
    messages.push(`Comments = '${commentsMatch}'`);
  }

  if (commentsInclud != null) {
    messages.push(`Comments contains '${commentsInclud}'`);
  }

  if (commentsNot != null) {
    messages.push(`Comments != '${commentsNot}'`);
  }

  /* ---------------------------------------------------------------------- */
  /* EARTHQUAKE SEARCH ---------------------------------------------------- */
  if (eqAssoc != null) {
    messages.push(`Eq Association = ${eqAssoc}`);
  }

  if (eqId != null) {
    messages.push(`Eq ID = ${eqId}`);
  }

  resolveMinMax('Eq ID', eqMinId, eqMaxId, messages);
  resolveMinMax('Eq Year', eqMinYear, eqMaxYear, messages);

  if (eqRegion != null) {
    messages.push(`Eq Region = ${resolveDescriptor(eqRegions, eqRegion)}`);
  }

  if (eqCountry != null) {
    messages.push(`Eq Country = ${eqCountry}`);
  }

  if (eqArea != null) {
    messages.push(`Eq Area = ${eqArea}`);
  }

  if (eqLocStart != null) {
    messages.push(`Eq Location starts with '${eqLocStart}'`);
  }

  if (eqLocMatch != null) {
    messages.push(`Eq Location = '${eqLocMatch}'`);
  }

  if (eqLocInclude != null) {
    messages.push(`Eq Location contains '${eqLocInclude}'`);
  }

  if (eqLocNot != null) {
    messages.push(`Eq Location != '${eqLocNot}'`);
  }

  resolveMinMax('Eq Latitude', eqMinLatitude, eqMaxLatitude, messages);
  resolveMinMax('Eq Longitude', eqMinLongitude, eqMaxLongitude, messages);
  resolveMinMax('Eq Earthquake Magnitude', eqMinEqMagnitude, eqMaxEqMagnitude, messages);
  resolveMinMax('Eq Earthquake Intensity', eqMinIntensity, eqMaxIntensity, messages);
  resolveMinMax('Eq Earthquake Depth', eqMinEqDepth, eqMaxEqDepth, messages);

  if (eqAssocVol != null) {
    messages.push(`Eq has associated volcano event = ${eqAssocVol}`);
  }

  if (eqAssocTsu != null) {
    messages.push(`Eq has associated tsunami = ${eqAssocTsu}`);
  }

  resolveMinMax('Eq Deaths', eqMinDeaths, eqMaxDeaths, messages);
  resolveMinMaxDescription('Eq Deaths Description', eqMinDeathsAmountOrder, eqMaxDeathsAmountOrder, peopleDescriptors, messages);
  resolveMinMax('Eq Damage Millions $', eqMinDamageMillionsDollars, eqMaxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Eq Damage Description', eqMinDamageAmountOrder, eqMaxDamageAmountOrder, damageDescriptors, messages);
  resolveMinMax('Eq Total Deaths', eqMinDeathsTotal, eqMaxDeathsTotal, messages);
  resolveMinMaxDescription('Eq Total Deaths Description', eqMinDeathsAmountOrderTotal, eqMaxDeathsAmountOrderTotal, peopleDescriptors, messages);

  if (eqCommentsStart != null) {
    messages.push(`Eq Comments start with '${eqCommentsStart}'`);
  }

  if (eqCommentsMatch != null) {
    messages.push(`Eq Comments = '${eqCommentsMatch}'`);
  }

  if (eqCommentsInclude != null) {
    messages.push(`Eq Comments contains '${eqCommentsInclude}'`);
  }

  if (eqCommentsNot != null) {
    messages.push(`Eq Comments != '${eqCommentsNot}'`);
  }

  /* ---------------------------------------------------------------------- */
  /* VOLCANO SEARCH ------------------------------------------------------- */
  if (volAssoc != null) {
    messages.push(`Volcano Association = ${volAssoc}`);
  }

  if (volId != null) {
    messages.push(`Vol ID = ${volId}`);
  }

  resolveMinMax('Vol ID', volMinId, volMaxId, messages);
  resolveMinMax('Vol Year', volMinYear, volMaxYear, messages);

  if (volRegion != null) {
    messages.push(`Vol Region = ${resolveDescriptor(volRegions, volRegion)}`);
  }

  if (volCountry != null) {
    messages.push(`Vol Country = ${volCountry}`);
  }

  if (volLocStart != null) {
    messages.push(`Vol Location starts with '${volLocStart}'`);
  }

  if (volLocMatch != null) {
    messages.push(`Vol Location = '${volLocMatch}'`);
  }

  if (volLocInclude != null) {
    messages.push(`Vol Location contains '${volLocInclude}'`);
  }

  if (volLocNot != null) {
    messages.push(`Vol Location != '${volLocNot}'`);
  }

  if (volNameStart != null) {
    messages.push(`Vol Name starts with '${volNameStart}'`);
  }

  if (volNameMatch != null) {
    messages.push(`Vol Name = '${volNameMatch}'`);
  }

  if (volNameInclude != null) {
    messages.push(`Vol Name contains '${volNameInclude}'`);
  }

  if (volNameNot != null) {
    messages.push(`Vol Name != '${volNameNot}'`);
  }

  resolveMinMax('Vol Latitude', volMinLatitude, volMaxLatitude, messages);
  resolveMinMax('Vol Longitude', volMinLongitude, volMaxLongitude, messages);

  if (volVolcanoNames != null) {
    messages.push(`Vol Volcano Name = ${volVolcanoNames}`);
  }

  if (volMorphology != null) {
    messages.push(`Vol Volcano Type = ${volMorphology}`);
  }

  if (volAssocEq != null) {
    messages.push(`Vol Has associated earthquake = ${volAssocEq}`);
  }

  if (volAssocTsu != null) {
    messages.push(`Vol Has associated tsunami = ${volAssocTsu}`);
  }

  resolveMinMax('Vol VEI', volMinVei, volMaxVei, messages);

  resolveMinMax('Vol Deaths', volMinDeaths, volMaxDeaths, messages);
  resolveMinMaxDescription('Vol Deaths Description', volMinDeathsAmountOrder, volMaxDeathsAmountOrder, peopleDescriptors, messages);
  resolveMinMax('Vol Damage Millions $', volMinDamageMillionsDollars, volMaxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Vol Damage Description', volMinDamageAmountOrder, volMaxDamageAmountOrder, damageDescriptors, messages);

  if (volCommentsStart != null) {
    messages.push(`Vol Comments start with '${volCommentsStart}'`);
  }

  if (volCommentsMatch != null) {
    messages.push(`Vol Comments = '${volCommentsMatch}'`);
  }

  if (volCommentsInclude != null) {
    messages.push(`Vol Comments contains '${volCommentsInclude}'`);
  }

  if (volCommentsNot != null) {
    messages.push(`Vol Comments != '${volCommentsNot}'`);
  }

  if (volCommentsEnd != null) {
    messages.push(`Vol Comments end with '${volCommentsEnd}'`);
  }

  /* ---------------------------------------------------------------------- */
  /* VOLCANO LOCATION SEARCH ---------------------------------------------- */
  if (volLocAssoc != null) {
    messages.push(`Volcano Location Association = ${volLocAssoc}`);
  }

  if (volLocRegion != null) {
    messages.push(`Vol Loc Region = ${resolveDescriptor(volLocRegions, volLocRegion)}`);
  }

  if (volLocCountry != null) {
    messages.push(`Vol Loc Country = ${volLocCountry}`);
  }

  if (volLocNameStart != null) {
    messages.push(`Vol Loc Name starts with '${volLocNameStart}'`);
  }

  if (volLocNameMatch != null) {
    messages.push(`Vol Loc Name = '${volLocNameMatch}'`);
  }

  if (volLocNameInclude != null) {
    messages.push(`Vol Loc Name contains '${volLocNameInclude}'`);
  }

  if (volLocNameNot != null) {
    messages.push(`Vol Loc Name != '${volLocNameNot}'`);
  }

  resolveMinMax('Vol Loc Latitude', volLocMinLatitude, volLocMaxLatitude, messages);
  resolveMinMax('Vol Loc Longitude', volLocMinLongitude, volLocMaxLongitude, messages);

  if (volLocMorphology != null) {
    messages.push(`Vol Loc Morphology = ${volLocMorphology}`);
  }

  if (volLocStatus != null) {
    messages.push(`Vol Loc Status = ${volLocStatus}`);
  }

  if (volLocTimeErupt != null) {
    messages.push(`Vol Loc Eruption time = ${volLocTimeErupt}`);
  }

  /* ---------------------------------------------------------------------- */
  /* TSUNAMI SEARCH ------------------------------------------------------- */
  if (tsuAssoc != null) {
    messages.push(`Tsunami Association = ${tsuAssoc}`);
  }

  if (tsuId != null) {
    messages.push(`Tsu ID = ${tsuId}`);
  }

  resolveMinMax('Tsu ID', tsuMinId, tsuMaxId, messages);

  resolveMinMax('Tsu Year', tsuMinYear, tsuMaxYear, messages);

  if (tsuRegionCode != null) {
    messages.push(`Tsu Region = ${resolveDescriptor(tsuRegions, tsuRegionCode)}`);
  }

  if (tsuCauseCode != null) {
    messages.push(`Tsu Cause Code = ${tsuCauseCode}`);
  }

  if (tsuCountry != null) {
    messages.push(`Tsu Country = ${tsuCountry}`);
  }

  if (tsuArea != null) {
    messages.push(`Tsu Area = ${tsuArea}`);
  }

  if (tsuLocStart != null) {
    messages.push(`Tsu Location starts with '${tsuLocStart}'`);
  }

  if (tsuLocMatch != null) {
    messages.push(`Tsu Location = '${tsuLocMatch}'`);
  }

  if (tsuLocInclude != null) {
    messages.push(`Tsu Location contains '${tsuLocInclude}'`);
  }

  if (tsuLocNot != null) {
    messages.push(`Tsu Location != '${tsuLocNot}'`);
  }

  if (tsuLocEnd != null) {
    messages.push(`Tsu Location ends with '${tsuLocEnd}'`);
  }

  resolveMinMax('Tsu Latitude', tsuMinLatitude, tsuMaxLatitude, messages);
  resolveMinMax('Tsu Longitude', tsuMinLongitude, tsuMaxLongitude, messages);

  resolveMinMaxDescription('Tsu Validity', tsuMinEventValidity, tsuMaxEventValidity, tsuValidities, messages);

  resolveMinMaxDescription('Tsu Cause', tsuMinCauseCode, tsuMaxCauseCode, tsuCauses, messages);

  resolveMinMax('Tsu Deaths', tsuMinDeaths, tsuMaxDeaths, messages);
  resolveMinMaxDescription('Tsu Deaths Description', tsuMinDeathsAmountOrder, tsuMaxDeathsAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Tsu Injuries', tsuMinInjuries, tsuMaxInjuries, messages);
  resolveMinMaxDescription('Tsu Injuries Description', tsuMinInjuriesAmountOrder, tsuMaxInjuriesAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Tsu Houses Destroyed', tsuMinHousesDestroyed, tsuMaxHousesDestroyed, messages);
  resolveMinMaxDescription('Tsu Houses Destroyed Description', tsuMinHousesDestroyedAmountOrder, tsuMaxHousesDestroyedAmountOrder, housesDescriptors, messages);

  resolveMinMax('Tsu Damage Millions $', tsuMinDamageMillionsDollars, tsuMaxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Tsu Damage Description', tsuMinDamageAmountOrder, tsuMaxDamageAmountOrder, damageDescriptors, messages);

  resolveMinMax('Tsu Total Deaths', tsuMinDeathsTotal, tsuMaxDeathsTotal, messages);
  resolveMinMaxDescription('Tsu Total Deaths Description', tsuMinDeathsAmountOrderTotal, tsuMaxDeathsAmountOrderTotal, peopleDescriptors, messages);

  resolveMinMax('Tsu Total Damage Millions $', tsuMinDamageMillionsDollarsTotal, tsuMaxDamageMillionsDollarsTotal, messages);
  resolveMinMaxDescription('Tsu Total Damage Description', tsuMinDamageAmountOrderTotal, tsuMaxDamageAmountOrderTotal, damageDescriptors, messages);

  resolveMinMax('Tsu Earthquake Magnitude', tsuMinEqMagnitude, tsuMaxEqMagnitude, messages);


  if (tsuRunupRegion != null) {
    messages.push(`Tsu Runup Region = ${resolveDescriptor(tsuRegions, tsuRunupRegion)}`);
  }

  if (tsuRunupCountry != null) {
    messages.push(`Tsu Runup Country = ${tsuRunupCountry}`);
  }

  if (tsuRunupArea != null) {
    messages.push(`Tsu Runup Area = ${tsuRunupArea}`);
  }

  if (tsuRunupLocStart != null) {
    messages.push(`Tsu Runup location starts with '${tsuRunupLocStart}'`);
  }

  if (tsuRunupLocMatch != null) {
    messages.push(`Tsu Runup Location = '${tsuRunupLocMatch}'`);
  }

  if (tsuRunupLocInclude != null) {
    messages.push(`Tsu Runup location contains '${tsuRunupLocInclude}'`);
  }

  if (tsuRunupLocNot != null) {
    messages.push(`Tsu Runup location != '${tsuRunupLocNot}'`);
  }

  if (tsuRunupLocEnd != null) {
    messages.push(`Tsu Runup location ends with '${tsuRunupLocEnd}'`);
  }

  if (tsuRunupMeasureType != null) {
    messages.push(`Tsu Measurement Type = ${resolveDescriptor(tsuRunupMeasurementTypes, tsuRunupMeasureType)}`);
  }

  resolveMinMax('Tsu Runup Height', tsuRunupMinHeight, tsuRunupMaxHeight, messages);

  resolveMinMax('Tsu Distance of Runup Location', tsuRunupMinDistance, tsuRunupMaxDistance, messages);
  resolveMinMax('Tsu Travel Time (Hours)', tsuRunupMinTravelTime, tsuRunupMaxTravelTime, messages);
  resolveMinMax('Tsu Number of Runups', tsuMinNumRunups, tsuMaxNumRunups, messages);
  resolveMinMax('Tsu Maximum Water Height', tsuMinMaxWaterHeight, tsuMaxMaxWaterHeight, messages);

  resolveMinMax('Tsu Runup Deaths', tsuRunupMinDeaths, tsuRunupMaxDeaths, messages);
  resolveMinMaxDescription('Tsu Runup Deaths Description', tsuRunupMinDeathsAmountOrder, tsuRunupMaxDeathsAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Tsu Runup Injuries', tsuRunupMinInjuries, tsuRunupMaxInjuries, messages);
  resolveMinMaxDescription('Tsu Runup Injuries Description', tsuRunupMinInjuriesAmountOrder, tsuRunupMaxInjuriesAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Tsu Runup Houses Destroyed', tsuRunupMinHousesDestroyed, tsuRunupMaxHousesDestroyed, messages);
  resolveMinMaxDescription('Tsu Runup Houses Destroyed Description', tsuRunupMinHousesDestroyedAmountOrder, tsuRunupMaxHousesDestroyedAmountOrder, housesDescriptors, messages);

  resolveMinMax('Tsu Runup Damage Millions $', tsuRunupMinDamageMillionsDollars, tsuRunupMaxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Tsu Runup Damage Description', tsuRunupMinDamageAmountOrder, tsuRunupMaxDamageAmountOrder, damageDescriptors, messages);

  if (tsuRunupDoubtful != null) {
    const d = tsuRunupDoubtful.toLocaleLowerCase();
    switch (d) {
      case 'n':
        messages.push('Tsu Doubtfulness = OK');
        break;
      case 'y':
        messages.push('Tsu Doubtfulness = Doubtful');
        break;
      case 'm':
        messages.push('Tsu Doubtfulness = Meteorological');
        break;
      case 'a':
        messages.push('Tsu Doubtfulness = Atmospheric');
        break;
      default:
        break;
    }
  }

  if (tsuCommentsStart != null) {
    messages.push(`Tsu Comments start with '${tsuCommentsStart}'`);
  }

  if (tsuCommentsMatch != null) {
    messages.push(`Tsu Comments = '${tsuCommentsMatch}'`);
  }

  if (tsuCommentsInclude != null) {
    messages.push(`Tsu Comments contains '${tsuCommentsInclude}'`);
  }

  if (tsuCommentsNot != null) {
    messages.push(`Tsu Comments != '${tsuCommentsNot}'`);
  }

  if (tsuCommentsEnd != null) {
    messages.push(`Tsu Comments end with '${tsuCommentsEnd}'`);
  }

  /* ---------------------------------------------------------------------- */
  /* DEPOSIT SEARCH ------------------------------------------------------- */
  if (depAssoc != null) {
    messages.push(`Deposit Association = ${depAssoc}`);
  }

  if (depId != null) {
    messages.push(`Dep ID = ${depId}`);
  }

  resolveMinMax('Dep ID', depMinId, depMaxId, messages);

  resolveMinMax('Dep Year', depMinYear, depMaxYear, messages);

  if (depAuthorStart != null) {
    messages.push(`Dep Author starts with '${depAuthorStart}'`);
  }

  if (depAuthorMatch != null) {
    messages.push(`Dep Author = '${depAuthorMatch}'`);
  }

  if (depAuthorInclude != null) {
    messages.push(`Dep Author contains '${depAuthorInclude}'`);
  }

  if (depAuthorNot != null) {
    messages.push(`Dep Author != '${depAuthorNot}'`);
  }

  if (depPublicationType != null) {
    messages.push(`Dep Publication = ${resolveDescriptor(depPublicationTypes, depPublicationType)}`);
  }

  if (depEventStart != null) {
    messages.push(`Dep Event starts with '${depEventStart}'`);
  }

  if (depEventMatch != null) {
    messages.push(`Dep Event = '${depEventMatch}'`);
  }

  if (depEventInclude != null) {
    messages.push(`Dep Event contains '${depEventInclude}'`);
  }

  if (depEventNot != null) {
    messages.push(`Dep Event != '${depEventNot}'`);
  }

  resolveMinMaxDescription('Dep Geologic Age', depMinGeologicAgeId, depMaxGeologicAgeId, depGeologicAges, messages);

  if (depBodyOfWater != null) {
    messages.push(`Dep Body of Water = ${depBodyOfWater}`);
  }

  if (depCountry != null) {
    messages.push(`Dep Country = ${depCountry}`);
  }

  if (depLocStart != null) {
    messages.push(`Dep Location starts with '${depLocStart}'`);
  }

  if (depLocMatch != null) {
    messages.push(`Dep Location = '${depLocMatch}'`);
  }

  if (depLocInclude != null) {
    messages.push(`Dep Location contains '${depLocInclude}'`);
  }

  if (depLocNot != null) {
    messages.push(`Dep Location != '${depLocNot}'`);
  }

  resolveMinMax('Dep Latitude', depMinLatitude, depMaxLatitude, messages);
  resolveMinMax('Dep Longitude', depMinLongitude, depMaxLongitude, messages);

  /* ---------------------------------------------------------------------- */
  /* RUNUP SEARCH --------------------------------------------------------- */
  if (runupAssoc != null) {
    messages.push(`Runup Association = ${runupAssoc}`);
  }

  if (runupId != null) {
    messages.push(`Runup ID = ${id}`);
  }

  resolveMinMax('Runup Year', runupSourceMinYear, runupSourceMaxYear, messages);

  resolveMinMax('Runup ID', runupMinId, runupMaxId, messages);

  if (runupSourceRegionCode != null) {
    messages.push(`Runup Source Region = ${resolveDescriptor(runupRegions, runupSourceRegionCode)}`);
  }

  if (runupSourceCountry != null) {
    messages.push(`Runup Source Country = ${runupSourceCountry}`);
  }

  if (runupSourceArea != null) {
    messages.push(`Runup Source Area = ${runupSourceArea}`);
  }

  resolveMinMaxDescription('Runup Source Validity', runupSourceMinEventValidity, runupSourceMaxEventValidity, runupValidities, messages);

  resolveMinMaxDescription('Runup Source Cause', runupSourceMinCauseCode, runupSourceMaxCauseCode, runupCauses, messages);

  resolveMinMax('Runup Earthquake Magnitude', runupSourceMinEqMagnitude, runupSourceMaxEqMagnitude, messages);

  if (runupRegionCode != null) {
    messages.push(`Runup Region = ${resolveDescriptor(runupRegions, runupRegionCode)}`);
  }

  if (runupCountry != null) {
    messages.push(`Runup Country = ${runupCountry}`);
  }

  if (runupArea != null) {
    messages.push(`Runup Area = ${runupArea}`);
  }

  if (runupRunupCountry != null) {
    messages.push(`Runup Runup Country = ${runupRunupCountry}`);
  }

  if (runupRunupArea != null) {
    messages.push(`Runup Runup Area = ${runupRunupArea}`);
  }

  resolveMinMax('Runup Distance from Source', runupMinDistFromSource, runupMaxDistFromSource, messages);

  resolveMinMax('Runup Travel Time (Hours)', runupMinTravHours, runupMaxTravHours, messages);

  if (runupTypeMeasurementId != null) {
    messages.push(`Runup Measurement Type = ${resolveDescriptor(runupRunupMeasurementTypes, runupTypeMeasurementId)}`);
  }

  resolveMinMax('Runup Runup Height', runupMinRunupHt, runupMaxRunupHt, messages);
  resolveMinMax('Runup Maximum Trough Height', runupMinTroughHt, runupMaxTroughHt, messages);
  resolveMinMax('Runup Maximum Inundation Distance', runupMinRunupHoriz, runupMaxRunupHoriz, messages);

  if (runupLocStart != null) {
    messages.push(`Runup Location starts with '${runupLocStart}'`);
  }

  if (runupLocMatch != null) {
    messages.push(`Runup Location = '${runupLocMatch}'`);
  }

  if (runupLocInclude != null) {
    messages.push(`Runup Location contains '${runupLocInclude}'`);
  }

  if (runupLocNot != null) {
    messages.push(`Runup Location != '${runupLocNot}'`);
  }

  resolveMinMax('Runup Latitude', runupMinLatitude, runupMaxLatitude, messages);
  resolveMinMax('Runup Longitude', runupMinLongitude, runupMaxLongitude, messages);


  resolveMinMax('Runup Deaths', runupMinDeaths, runupMaxDeaths, messages);
  resolveMinMaxDescription('Runup Deaths Description', runupMinDeathsAmountOrder, runupMaxDeathsAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Runup Injuries', runupMinInjuries, runupMaxInjuries, messages);
  resolveMinMaxDescription('Runup Injuries Description', runupMinInjuriesAmountOrder, runupMaxInjuriesAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Runup Houses Destroyed', runupMinHousesDestroyed, runupMaxHousesDestroyed, messages);
  resolveMinMaxDescription('Runup Houses Destroyed Description', runupMinHousesDestroyedAmountOrder, runupMaxHousesDestroyedAmountOrder, housesDescriptors, messages);

  resolveMinMax('Runup Houses Damaged', runupMinHousesDamaged, runupMaxHousesDamaged, messages);
  resolveMinMaxDescription('Runup Houses Damaged Description', runupMinHousesDamagedAmountOrder, runupMaxHousesDamagedAmountOrder, housesDescriptors, messages);

  resolveMinMax('Runup Damage Millions $', runupMinDamageMillionsDollars, runupMaxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Runup Damage Description', runupMinDamageAmountOrder, runupMaxDamageAmountOrder, damageDescriptors, messages);

  if (runupDoubtful != null) {
    const d = runupDoubtful.toLocaleLowerCase();
    switch (d) {
      case 'n':
        messages.push('Runup Doubtfulness = Doubtful');
        break;
      case 'y':
        messages.push('Runup Doubtfulness = OK');
        break;
      case 'm':
        messages.push('Runup Doubtfulness = Meteorological');
        break;
      case 'a':
        messages.push('Tsu Doubtfulness = Atmospheric');
        break;
      default:
        break;
    }
  }

  if (runupCommentsStart != null) {
    messages.push(`Runup Comments start with '${runupCommentsStart}'`);
  }

  if (runupCommentsMatch != null) {
    messages.push(`Runup Comments = '${runupCommentsMatch}'`);
  }

  if (runupCommentsInclude != null) {
    messages.push(`Runup Comments contains '${runupCommentsInclude}'`);
  }

  if (runupCommentsNot != null) {
    messages.push(`Runup Comments != '${runupCommentsNot}'`);
  }

  if (runupTsunamiEventId != null) {
    messages.push(`Runup Tsunami ID ='${runupTsunamiEventId}'`);
  }

  return messages;
};
